// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { StoragePricingOperationsService } from '../generated/api/storagePricingOperations.service';

@Injectable({ providedIn: 'root' })
export class StoragePricingOperationsClientService {
  constructor(private readonly client: StoragePricingOperationsService) {}
  // <generated-client-wrappers:methods>
  current(
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.StoragePricingVersionDetails> {
    if (!this.client)
      throw new Error('StoragePricingOperationsService is not available');
    return this.client.storagePricingOperationsCurrent(
      'body',
      reportProgress,
      options,
    );
  }

  providerPrice(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.StorageProviderPriceResponse> {
    if (!this.client)
      throw new Error('StoragePricingOperationsService is not available');
    return this.client.storagePricingOperationsProviderPrice(
      id,
      'body',
      reportProgress,
      options,
    );
  }

  providerPrices(
    providerAccountKey?: string,
    unit?: 1 | 2 | 3,
    currency?: string,
    page?: number,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.StorageReferencePricePage> {
    if (!this.client)
      throw new Error('StoragePricingOperationsService is not available');
    return this.client.storagePricingOperationsProviderPrices(
      providerAccountKey,
      unit,
      currency,
      page,
      'body',
      reportProgress,
      options,
    );
  }

  publish(
    request: WrapperApi.StoragePricingPublication,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.StoragePricingPublicationReceipt> {
    if (!this.client)
      throw new Error('StoragePricingOperationsService is not available');
    return this.client.storagePricingOperationsPublish(
      request,
      'body',
      reportProgress,
      options,
    );
  }

  publishProviderPrice(
    request: WrapperApi.StorageProviderPricePublication,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.StorageProviderPriceResponse> {
    if (!this.client)
      throw new Error('StoragePricingOperationsService is not available');
    return this.client.storagePricingOperationsPublishProviderPrice(
      request,
      'body',
      reportProgress,
      options,
    );
  }

  referencePrices(
    unit?: 1 | 2 | 3,
    currency?: string,
    page?: number,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.StorageReferencePricePage> {
    if (!this.client)
      throw new Error('StoragePricingOperationsService is not available');
    return this.client.storagePricingOperationsReferencePrices(
      unit,
      currency,
      page,
      'body',
      reportProgress,
      options,
    );
  }

  version(
    id: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.StoragePricingVersionDetails> {
    if (!this.client)
      throw new Error('StoragePricingOperationsService is not available');
    return this.client.storagePricingOperationsVersion(
      id,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
